import { createAsyncThunk } from "@reduxjs/toolkit";
import { contactListAPI, getAreaForContact } from "../../Api/ContactApi";
import { fetchContactStart, fetchContactSuccess, fetchContactFailure, fetchContactSuccessAndSetSelectedEmployee, fetchContactSuccessAndSetSelectedProfessional, fetchContactSuccessAndSetSelectedComClient, fetchContactSuccessAndSetSelectedDomClient, fetchContactSuccessAndDeleteProjectComClient } from "../Slices/contactSlice";
import { AppDispatch } from "../Store";
import { mapEmployeeAreaLists } from "../Types/EmployeeInterface";

export const fetchAllContact = () => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await contactListAPI();
        if(data.status){
            dispatch(fetchContactSuccess(data.data || []))
        }else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}

export const fetchAllContactAfterEditEmployeeDetails = () => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await contactListAPI();
        if(data.status){
            dispatch(fetchContactSuccessAndSetSelectedEmployee(data.data || []))
        }else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}

export const fetchAllContactAfterEditProfessionalDetails = () => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await contactListAPI();
        if(data.status){
            dispatch(fetchContactSuccessAndSetSelectedProfessional(data.data || []))
        }else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}

export const fetchAllContactAfterEditClientDetails = () => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await contactListAPI();
        if(data.status){
            dispatch(fetchContactSuccessAndSetSelectedComClient(data.data || []))
        }else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}


export const fetchContactSuccessAfterDeleteProjectComClient = () => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await contactListAPI();
        if(data.status){
            dispatch(fetchContactSuccessAndDeleteProjectComClient(data.data || []))
        }else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}

export const fetchAllContactAfterEditDomClientDetails = () => async(dispatch: AppDispatch) => {
    try {
        dispatch(fetchContactStart())
        const data = await contactListAPI();
        if(data.status){
            dispatch(fetchContactSuccessAndSetSelectedDomClient(data.data || []))
        }else {
            dispatch(fetchContactFailure(data.massage || ''))
        }
    } catch (e) {
        dispatch(fetchContactFailure(e!.toString()))
    }
}


// get Contact area list
export const getContactAreaList = createAsyncThunk<
  ReturnType<typeof mapEmployeeAreaLists>,
  void | { force?: boolean },
  {
    rejectValue: string;
    state: { contactAreaList: { loader: boolean; loaded: boolean } };
  }
>('getContactAreaList', async (_, { rejectWithValue }) => {
  try {
    const response = await getAreaForContact();
    if (response.status) {
      return mapEmployeeAreaLists(response.body);
    }
    return rejectWithValue(response.error || 'Failed to fetch contact areas');
  } catch (error: any) {
    return rejectWithValue('Failed to fetch contact areas');
  }
}, {
  condition: (options, { getState }) => {
    const { loader, loaded } = getState().contactAreaList;
    if (loader) return false;
    return Boolean(options?.force) || !loaded;
  },
});


